import React, { Component } from 'react'
import MyNavbar from "../../components/Navbar/MyNavbar";
import TimesheetSystem from '../../components/Ticket/TimesheetSystem/TimesheetSystem';
export default class TimesheetSystemPage extends Component {
    
    render() {
        return (
            <div>
                 <MyNavbar />
                 <TimesheetSystem/>
            </div>
        )
    }
}